"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MotivationForJoiningFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../fields");

var _motivationForJoiningConfig = require("./motivationForJoiningConfig");

var _selectConfigWithAdditionalItems = _interopRequireDefault(require("../../utils/selectConfigWithAdditionalItems"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var MotivationForJoiningDefinition = _flowRuntime["default"].tdz(function () {
  return _motivationForJoiningConfig.MotivationForJoiningDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("motivationForJoining", _flowRuntime["default"].ref(MotivationForJoiningDefinition))));

var MotivationForJoiningFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MotivationForJoiningFields, _React$Component);

  var _super = (0, _createSuper2["default"])(MotivationForJoiningFields);

  function MotivationForJoiningFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, MotivationForJoiningFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleChange = function () {
      var resetFields = _this.props.resetFields;
      resetFields();
    };

    return _this;
  }

  (0, _createClass2["default"])(MotivationForJoiningFields, [{
    key: "render",
    value: function render() {
      var motivationForJoining = this.props.motivationForJoining;
      return /*#__PURE__*/_react["default"].createElement(_fields.Select, {
        key: _motivationForJoiningConfig.motivationForJoiningSelect.key,
        id: _motivationForJoiningConfig.motivationForJoiningSelect.key,
        select: (0, _selectConfigWithAdditionalItems["default"])(_motivationForJoiningConfig.motivationForJoiningSelect, _motivationForJoiningConfig.motivationForJoiningItems, motivationForJoining.items),
        onChange: this.handleChange
      });
    }
  }]);
  return MotivationForJoiningFields;
}(_react["default"].Component);

exports.MotivationForJoiningFields = MotivationForJoiningFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    reasonOption: selector(state, "".concat(componentKey, ".reason"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var componentKey = ownProps.componentKey;
  var reasonPath = "".concat(componentKey, ".reason");
  var fields = [reasonPath];
  return {
    resetFields: function resetFields() {
      Promise.all([dispatch((0, _reduxForm.change)('form', reasonPath, '')), dispatch(_reduxForm.untouch.apply(void 0, ['form'].concat(fields)))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MotivationForJoiningFields);

exports["default"] = _default;